import Script from "next/script";

import { ONETRUST_CONFIG } from "./constants";
import { isProduction } from "../../utils/environment";

/**
 * OneTrust cookie consent script for GDPR/CCPA compliance.
 *
 * The "Manage cookies" button visibility is handled via CSS in globals.css.
 *
 * Uses test domain script ID in non-production environments.
 * Uses beforeInteractive strategy per OneTrust docs to ensure consent
 * is checked before other scripts run.
 *
 * @see https://gitlab.com/zapier/design-systems/cookie-consent/-/tree/main/packages/cookie-consent#onetrust-cookie-consent-script
 */
export function OneTrustCookieConsentScript() {
  const domainScriptId = isProduction
    ? ONETRUST_CONFIG.domainScriptId
    : ONETRUST_CONFIG.testDomainScriptId;

  return (
    <Script
      data-domain-script={domainScriptId}
      id={ONETRUST_CONFIG.elementId}
      src={ONETRUST_CONFIG.scriptSrc}
      strategy="beforeInteractive"
    />
  );
}
